import {IFintechLayout} from "../../types/types"
const defaultColor="#1b6cb5"
const hexToRgb = (hex: string) => {
    // Remove the leading # if it's there
    hex = hex.replace(/^#/, "");

    // Parse the r, g, b values
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Normalize the RGB values to be between 0 and 1 (feColorMatrix expects normalized values)
    return { r: r / 255, g: g / 255, b: b / 255 };
  };

 interface ISubscriptionManagementLogoProps {
    layout:IFintechLayout | null
    isPaid:boolean
  }
const  SubscriptionManagementLogo:React.FC<ISubscriptionManagementLogoProps> = ({layout,isPaid}) => 
{
    const gradientRgb = hexToRgb(layout?.gradientColorStart??defaultColor);
    const isDarkMode=document.body.classList.contains('dark');
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="186"
        height="186"
        viewBox="0 0 186 186"
        fill="none"
        >
        <defs>
            <filter id="blur" filterUnits="userSpaceOnUse" x="0" y="0" width="180" height="180">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
            </filter>

        </defs>
  
        <circle cx="93" cy="89" r="58" stroke={layout?.gradientColorStart??defaultColor} stroke-width="3" fill="none" opacity="1" />
        <circle cx="93" cy="89" r="61" stroke={layout?.gradientColorStart??defaultColor} stroke-width="5" fill="none" filter="url(#blur)" opacity="0.9" />        
        <g >
         

        {/* Nested SVG */}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
            x="57" // Adjust the x position (186 / 2 - 72 / 2 = 57)
            y="47" // Adjust the y position (186 / 2 - 72 / 2 = 47)
            viewBox="0 0 72 72"
            fill="none"
        >
  
            <g >
            <mask

            >
            <rect width="72" height="72" fill={isDarkMode ? "#EBECF0":"#2C2C2C" } />
            </mask>
            <g mask="url(#mask0_16370_1570)">
                {isPaid &&
                    <path
                    d="M12.9233 58.5C11.4077 58.5 10.125 57.975 9.075 56.925C8.025 55.875 7.5 54.5923 7.5 53.0768V18.9233C7.5 17.4078 8.025 16.125 9.075 15.075C10.125 14.025 11.4077 13.5 12.9233 13.5H59.0768C60.5923 13.5 61.875 14.025 62.925 15.075C63.975 16.125 64.5 17.4078 64.5 18.9233V32.631C64.5 33.2345 64.2913 33.745 63.8737 34.1625C63.4567 34.5795 62.9463 34.788 62.3423 34.788C60.9767 34.788 59.6653 34.9738 58.4078 35.3453C57.1498 35.7163 56.044 36.3788 55.0905 37.3328L44.3887 48.1095L42.0518 45.7905C40.3213 44.0595 38.2502 43.2018 35.8387 43.2173C33.4268 43.2328 31.3555 44.1058 29.625 45.8363C28.102 47.3593 27.2432 49.0583 27.0487 50.9333C26.8547 52.8083 27.2135 54.592 28.125 56.2845C28.4055 56.777 28.418 57.2693 28.1625 57.7613C27.9065 58.2538 27.5325 58.5 27.0405 58.5H12.9233ZM12 25.212V34.788H60V25.212H12ZM44.3887 57.3923L59.769 42.0113C60.2155 41.5653 60.7452 41.3453 61.3582 41.3513C61.9717 41.3568 62.5112 41.5923 62.9768 42.0578C63.4113 42.5233 63.6363 43.05 63.6518 43.638C63.6673 44.2265 63.4423 44.7535 62.9768 45.219L46.2863 61.9095C46.0058 62.19 45.7098 62.3958 45.3983 62.5268C45.0868 62.6578 44.7502 62.7233 44.3887 62.7233C44.0462 62.7233 43.7145 62.6578 43.3935 62.5268C43.072 62.3958 42.771 62.19 42.4905 61.9095L34.2577 53.6768C33.8422 53.2613 33.622 52.7467 33.597 52.1333C33.572 51.5203 33.7922 50.981 34.2577 50.5155C34.6922 50.081 35.2115 49.8638 35.8155 49.8638C36.419 49.8638 36.9535 50.081 37.419 50.5155L44.3887 57.3923Z" 
                    fill={layout?.gradientColorStart??defaultColor}
                    />
                }
                {!isPaid &&
                    <path
                    d="M54.8363 50.4285V43.4422C54.8363 43.0807 54.7055 42.7692 54.444 42.5077C54.1825 42.2462 53.871 42.1155 53.5095 42.1155C53.148 42.1155 52.8365 42.2462 52.575 42.5077C52.3135 42.7692 52.1828 43.0807 52.1828 43.4422V50.3827C52.1828 50.7442 52.248 51.0885 52.3785 51.4155C52.5095 51.7425 52.7152 52.0462 52.9958 52.3268L57.6862 57.0173C57.9478 57.2787 58.2545 57.4143 58.6065 57.4238C58.9585 57.4338 59.275 57.2982 59.556 57.0173C59.8365 56.7367 59.9768 56.4253 59.9768 56.0828C59.9768 55.7403 59.8365 55.4288 59.556 55.1483L54.8363 50.4285ZM53.556 64.9328C49.6445 64.9328 46.327 63.5837 43.6035 60.8857C40.8805 58.1878 39.519 54.883 39.519 50.9715C39.519 47.06 40.8805 43.7503 43.6035 41.0423C46.327 38.3348 49.6445 36.981 53.556 36.981C57.4365 36.981 60.7258 38.3425 63.4238 41.0655C66.1217 43.7885 67.4707 47.0905 67.4707 50.9715C67.4707 54.852 66.1217 58.149 63.4238 60.8625C60.7258 63.576 57.4365 64.9328 53.556 64.9328ZM12.9233 58.5C11.4077 58.5 10.125 57.975 9.075 56.925C8.025 55.875 7.5 54.5923 7.5 53.0768V18.9233C7.5 17.4077 8.025 16.125 9.075 15.075C10.125 14.025 11.4077 13.5 12.9233 13.5H59.0768C60.5923 13.5 61.875 14.025 62.925 15.075C63.975 16.125 64.5 17.4077 64.5 18.9233V30.5422C64.5 31.1807 64.2845 31.7155 63.8535 32.1465C63.423 32.577 62.8885 32.7922 62.25 32.7922C61.6115 32.7922 61.077 32.577 60.6465 32.1465C60.2155 31.7155 60 31.1807 60 30.5422V25.212H12V34.788H36.7215C37.456 34.788 37.9753 35.14 38.2793 35.844C38.5828 36.548 38.4693 37.1885 37.9388 37.7655C36.3193 39.454 35.046 41.427 34.119 43.6845C33.192 45.942 32.7285 48.342 32.7285 50.8845C32.7285 51.6615 32.772 52.426 32.859 53.178C32.9455 53.93 33.0847 54.654 33.2767 55.35C33.4692 56.142 33.327 56.865 32.85 57.519C32.373 58.173 31.748 58.5 30.975 58.5H12.9233Z"
                    fill={layout?.gradientColorStart??defaultColor}
                    />
                }
            </g>
            
            </g>

            <defs>

            </defs>
        </svg>
        </g>
        <defs>

        </defs>
        </svg>
    )
}

export default SubscriptionManagementLogo